'use client';
import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { useRouter } from '@/intl/navigation';
import appRoutes from '@/constants/routes';
import AfiwaButton from '@/ui/shared/components/afiwaButton';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

function GetStartedSection() {
  const router = useRouter(); // Hook for navigation

  const getStartedText = useTranslations('contact_us.get_started');

  return (
    <div
      className={`bg-second-gradient relative  my-32 flex flex-col justify-center gap-y-10 rounded-[40px] py-10 md:my-20  md:gap-y-0   md:px-0 md:pb-16 `}
    >
      {/* bg-image */}
      <Image
        src={'/contact_us/dotted-bg.png'}
        alt="bg-image"
        height={350}
        width={360}
        className={'!absolute right-16 top-0 hidden lg:block'}
      />

      {/* content section */}
      <div className="z-10 mx-auto flex flex-col justify-center text-white md:mx-0 md:justify-start md:pb-20 md:pl-16 ">
        <div className="mb-10 flex flex-col gap-2 font-extrabold  md:gap-3">
          <div className="text-center text-base md:text-left md:text-xl">
            {getStartedText('get_started')}
          </div>
          <div className="text-center  text-lg md:text-left md:text-2xl lg:text-4xl">
            {getStartedText('join_afiwa_exchange')}
          </div>
        </div>
        <AfiwaButton
          type="default"
          size="large"
          className="!text-primary"
          href={appRoutes.login}
          text={getStartedText('create_account')}
          rightIcon={<ArrowRightIcon height={15} width={15} />}
          onClick={() => router.push(appRoutes.home)}
        />
      </div>

      {/* float image section */}
      <div className="-top-[25px] z-10 mx-auto px-5 md:absolute md:right-3 lg:right-10">
        <div
          className={`relative flex h-[350px] w-[320px] justify-center rounded-2xl bg-white p-3 md:max-w-[350px] `}
        >
          <div className="flex flex-col justify-start ">
            <Image
              src="/contact_us/blue_logo.png"
              alt="Blue logo"
              width={60}
              height={60}
            />
            <div className="ml-1  font-medium text-primary-pale ">
              {`${getStartedText('testimony')}`}
            </div>
          </div>

          <Image
            className="absolute -left-5 bottom-6 h-[150px] w-[250px] md:h-[200px] md:w-[300px]"
            src="/contact_us/two_phones.svg"
            alt="Two phones"
            width={400}
            height={300}
          />
        </div>
      </div>
    </div>
  );
}

export default GetStartedSection;
